export const LOAD_STORED_STATE = 'listDetail/loadStoredState';

export interface LoadStoredStateAction {
  type: typeof LOAD_STORED_STATE;
  payload: {
    leadList?: any;
    secondaryFilter?: any;
  };
}
